<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">

      <!-- HEADER -->
      <SubpageHeader
        :is_sticky="true"
        :is_create_screen="is_new_img"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="test()"
        @saveBtnClicked="test('save')"
        @cancelBtnClicked="test('cancel')"
      >
      </SubpageHeader>

      <!-- ACTUAL CONTENT -->
      <div class="work-package-image-detail-container">
        <div
          class="work-package-image-detail-content"
          :style="is_new_img ? 'margin-top: 20px' : ''"
        >

          <!-- NAVIGATION -->
          <div v-if="!is_new_img" class="work-package-image-detail-naviagtion">
            <!-- SHOW PREVIOUS -->
            <button
              class="work-package-image-detail-navigation-button"
              :style="`border-color:${fg};`"
              v-ripple
              @click="updateCurrentIndex(-1)"
            >
              <v-icon :color="fg">
                mdi-arrow-left-thick
              </v-icon>
            </button>
            <!-- IMAGE NUMBER -->
            <TText
              :text="`${current_index + 1}/${images.length}`"
              :size="14"
              :color="fg"
            />
            <!-- SHOW NEXT -->
            <button
              class="work-package-image-detail-navigation-button"
              :style="`border-color:${fg};`"
              v-ripple
              @click="updateCurrentIndex(1)"
            >
              <v-icon :color="fg">
                mdi-arrow-right-thick
              </v-icon>
            </button>
          </div>

          <!-- IMAGE -->
          <v-img
            class="work-package-image-detail-img"
            aspect-ratio="1"
            :src="images[current_index].image"
          />

          <!-- TEXT FIELDS -->
          <div class="work-package-image-detail-text-fields">
            <!-- DESCRIPTION -->
            <v-text-field
              label="Description"
              :value="images[current_index].description"
              :readonly="!is_edit_mode && !is_new_img"
              :color="fg"
              :light="is_light_mode(fg)"
              :clearable="is_edit_mode || is_new_img"
              dense
            />
            <!-- STEP TYPE -->
            <v-text-field
              v-if="!is_edit_mode && !is_new_img"
              label="Step type"
              :value="images[current_index].step_type"
              placeholder="No step type"
              :persistent-placeholder="images[current_index].step_type ? false : true"
              readonly
              :color="fg"
              :light="is_light_mode(fg)"
              :clearable="false"
              dense
            />
            <DropDown
              v-else
              label="Step type"
              :items="[
                'LOGISTIC.step', 'DESIGN.step', 'WORK.step',
                'QUALITY.step', 'DEFECT.step', 'HANDOVER.step',
                'MATERIAL.step', 'TOOL.step', 'SENSOR.step',
                'ROBOTICS.step'
              ]"
              :default_item="images[current_index].step_type"
              placeholder="Choose a step type..."
              :clearable="true"
              padding="0 0 16px 0"
              :light="is_light_mode(fg)"
              :background_color="bg"
              :foreground_color="fg"
              @selected="handleStepTypeUpdate($event)"
            />
            <!-- CONCRETE STEP -->
            <v-text-field
              v-if="!is_edit_mode && !is_new_img"
              label="Step"
              :value="images[current_index].step"
              placeholder="No concrete step"
              :persistent-placeholder="images[current_index].step ? false : true"
              readonly
              :color="fg"
              :light="is_light_mode(fg)"
              :clearable="false"
              dense
            />
            <DropDown
              v-else
              label="Step"
              :items="[
                'My Step 1', 'My Step 2', 'My Step 3',
                'My Step 4', 'My Step 5', 'My Step 6',
                'My Step 7', 'My Step 8', 'My Step 9',
              ]"
              :default_item="images[current_index].step"
              placeholder="Choose a concrete step..."
              :clearable="true"
              :disabled="images[current_index].step_type ? false : true"
              padding="0 0 16px 0"
              :light="is_light_mode(fg)"
              :background_color="bg"
              :foreground_color="fg"
              @selected="handleStepUpdate($event)"
            />
            <!-- PERSON -->
            <v-text-field
              label="Person"
              :value="images[current_index].person"
              readonly
              :color="fg"
              :light="is_light_mode(fg)"
              dense
            />
            <!-- DATE -->
            <v-text-field
              label="Date"
              :value="images[current_index].date"
              readonly
              :color="fg"
              :light="is_light_mode(fg)"
              dense
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import TText from '@/components/Taktify/TText.component.vue';
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';

  export default {
    components: {
      SubpageHeader,
      TText,
      DropDown,
    },

    mixins: [
      WorkPackageWIPMixin,
    ],

    computed: {

    },

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      cancel_color: '#F44336', // TODO: no colors in work packages

      current_index: 0,
      is_edit_mode: false,
      is_new_img: false,

      delta_foreground_color: '',
      delta_light_mode: '',

      // NOTE: these are supposed to be in the store or at least be loaded into it when necessary
      images: [
        {
          image: 'https://images.pexels.com/photos/9544524/pexels-photo-9544524.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Felsen',
          step_type: 'ROBOTICS.step',
          step: 'My Step 1',
          date: '2021-10-21',
          person: 'Timo Vogelsang',
        },
        {
          image: 'https://images.pexels.com/photos/6889376/pexels-photo-6889376.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Lampe',
          step_type: '',
          step: '',
          date: '2021-12-12',
          person: 'Jürgen Pape',
        },
        {
          image: 'https://images.pexels.com/photos/10214542/pexels-photo-10214542.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260',
          description: 'Brücke',
          step_type: '',
          step: '',
          date: '2021-12-13',
          person: 'Jürgen Pape',
        },
        {
          image: 'https://images.pexels.com/photos/10117700/pexels-photo-10117700.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Komode',
          step_type: '',
          step: '',
          date: '2021-12-13',
          person: 'Florian Genz',
        },
        {
          image: 'https://images.pexels.com/photos/8090531/pexels-photo-8090531.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Cascade',
          step_type: 'WORK.step',
          step: 'My Step 3',
          date: '2021-11-22',
          person: 'Schreier, Klaus',
        },
        {
          image: 'https://images.pexels.com/photos/9715702/pexels-photo-9715702.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Blätter',
          step_type: 'HANDOVER.step',
          step: 'My Step 5',
          date: '2021-11-22',
          person: 'Marco Herold',
        },
        {
          image: 'https://images.pexels.com/photos/2128159/pexels-photo-2128159.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
          description: 'Riesenrad',
          step_type: 'TOOL.step',
          step: 'My Step 4',
          date: '2021-12-23',
          person: 'Marco Herold',
        },
        {
          image: 'https://images.pexels.com/photos/190219/pexels-photo-190219.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Abend',
          step_type: 'SENSOR.step',
          step: 'My Step 9',
          date: '2021-10-21',
          person: 'Timo Vogelsang',
        },
      ]
    }),

    methods: {

      // Navigates between images
      updateCurrentIndex(val) {
        let index = this.current_index + val;
        if(index < 0) {
          this.current_index = this.images.length - 1;
        }
        else if(index >= this.images.length) {
          this.current_index = 0;
        }
        else {
          this.current_index = index;
        }
      },

      // TODO: this needs to mutate store
      handleStepTypeUpdate(new_value) {
        this.images[this.current_index].step_type = new_value;
        // if another step type is chosen the current step needs to be resetted either way
        // TODO: also needs to mutate
        this.images[this.current_index].step = '';
      },

      // TODO: this needs to mutate store
      handleStepUpdate(new_value) {
        this.images[this.current_index].step = new_value;
      },
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
  .work-package-image-detail-container {
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
  }
  .work-package-image-detail-head {
    display: flex;
    justify-content: space-between;
  }
  .work-package-image-detail-head-spacer {
    margin-top: 30px; /* 10px from frame, 20px from margin */
  }
  .work-package-image-detail-content {
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
  }
  .work-package-image-detail-naviagtion {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .work-package-image-detail-navigation-button {
    width: 50px;
    height: 50px;
    border: 1px solid;
    border-radius: 4px;
  }
  .work-package-image-detail-img {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .25);
  }
  .work-package-image-detail-text-fields {
    display: flex;
    flex-direction: column;
    padding-top: 8px;
  }
  .work-package-image-detail-new-image {
    display: flex;
    width: 100%;
    /* justify-content: space-between; */
    justify-content: center;
    grid-gap: 24px;
  }
</style>
